/* CUSTOM - product personalization form (image preview + text counter) */
(function () {
  'use strict';

  var MAX_BYTES = 20 * 1024 * 1024; // 20 MB (Shopify line item property file limit)
  var ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];

  function formatSize(bytes) {
    if (bytes >= 1048576) return (bytes / 1048576).toFixed(1) + ' MB';
    if (bytes >= 1024) return Math.round(bytes / 1024) + ' KB';
    return bytes + ' B';
  }

  function initFileInput(input) {
    if (input.dataset.pzReady === 'true') return;
    input.dataset.pzReady = 'true';

    var field = input.closest('.product-personalization__image') || input.parentNode;
    var preview = field.querySelector('.js-personalization-preview');
    var error = field.querySelector('.js-personalization-error');

    function showError(message) {
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
    }

    function clearError() {
      if (!error) return;
      error.textContent = '';
      error.hidden = true;
    }

    function resetPreview() {
      if (!preview) return;
      preview.innerHTML = '';
      preview.hidden = true;
    }

    input.addEventListener('change', function () {
      clearError();
      resetPreview();

      var file = input.files && input.files[0];
      if (!file) return;

      if (ALLOWED_TYPES.indexOf(file.type) === -1) {
        showError('Please choose an image file (JPG, PNG, WEBP, GIF).');
        input.value = '';
        return;
      }

      if (file.size > MAX_BYTES) {
        showError('Image is too large. Maximum size is 20 MB.');
        input.value = '';
        return;
      }

      if (!preview) return;

      var objectUrl = URL.createObjectURL(file);

      var img = document.createElement('img');
      img.className = 'product-personalization__preview-img';
      img.alt = file.name;
      img.src = objectUrl;
      img.addEventListener('load', function () { URL.revokeObjectURL(objectUrl); });

      var meta = document.createElement('span');
      meta.className = 'product-personalization__preview-meta small-text';
      meta.textContent = file.name + ' (' + formatSize(file.size) + ')';

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'product-personalization__preview-remove';
      remove.textContent = 'Remove';
      remove.addEventListener('click', function () {
        input.value = '';
        resetPreview();
        clearError();
      });

      preview.appendChild(img);
      preview.appendChild(meta);
      preview.appendChild(remove);
      preview.hidden = false;
    });
  }

  function initTextCounter(input) {
    if (input.dataset.pzReady === 'true') return;
    input.dataset.pzReady = 'true';

    var counter = input.parentNode.querySelector('.product-personalization__counter');
    if (!counter) return;

    var max = input.getAttribute('maxlength') || '';

    function update() {
      counter.textContent = input.value.length + '/' + max;
    }

    input.addEventListener('input', update);
    update();
  }

  function init(root) {
    var scope = root || document;
    var files = scope.querySelectorAll('.js-personalization-file');
    var texts = scope.querySelectorAll('.js-personalization-text');
    Array.prototype.forEach.call(files, initFileInput);
    Array.prototype.forEach.call(texts, initTextCounter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Re-initialize after Theme Editor section reloads.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
